<template>
  <div>
    <b-message type="is-info" class="is-size-7">
      Enter the details of a recent FedEx invoice to verify your account ownership.
    </b-message>
    <b-field label="Name">
      <b-input v-model="form.name" size="is-medium" @input="announce" />
    </b-field>
    <b-field label="Invoice Number">
      <b-input v-model="form.invoice_number" size="is-medium" @input="announce" />
    </b-field>
    <b-field label="Invoice Date">
      <b-input v-model="form.invoice_date" size="is-medium" type="date" @input="announce" />
    </b-field>
    <div class="columns">
      <div class="column is-half">
        <b-field label="Invoice Amount">
          <b-input v-model="form.invoice_amount" size="is-medium" placeholder="e.g. 1868.00" @input="announce" />
        </b-field>
      </div>
      <div class="column is-half">
        <b-field label="Invoice Currency">
          <b-input v-model="form.invoice_currency" size="is-medium" placeholder="e.g. USD" maxlength="3" @input="announce" />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        name: null,
        invoice_number: null,
        invoice_date: null,
        invoice_amount: null,
        invoice_currency: null
      }
    }
  },
  computed: {
    valid () {
      return !!(this.form.name && this.form.invoice_number && this.form.invoice_date && this.form.invoice_amount && this.form.invoice_currency)
    }
  },
  methods: {
    announce () {
      this.$emit('input', this.valid ? this.form : null)
    }
  }
}
</script>
